module.exports = __webpack_public_path__ + "media/images/appnexus_logo-7d8a6f6046facdf67cb5caacbed71e43.png";